"use client";

import { c as _c } from "react/compiler-runtime";
import { ContactForm } from "@/components/contact/ContactForm";
import { CONTACT_EMAIL } from "@/lib/site";
import { useT } from "@/lib/use-i18n";
export function ContactContent() {
  const $ = _c(51);
  const t = useT();
  let t0;
  if ($[0] !== t) {
    t0 = t("contactSupport");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="section-kicker mb-4">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("contactPageTitle");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("contactPageTitleItalic");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span className="font-normal text-foreground-soft">{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <h1 className="text-display text-foreground">{t2}{" "}{t4}</h1>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("contactPageBody");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <p className="mt-5 text-base leading-relaxed tracking-tight text-foreground-soft text-pretty">{t6}</p>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("contactPageEmail");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <p className="mb-2 block text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{t8}</p>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href={`mailto:${CONTACT_EMAIL}`} dir="ltr" className="link-underline inline-block font-mono text-[15px] font-medium tracking-tight text-foreground break-all hover:text-[var(--accent-deep)] transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]">{CONTACT_EMAIL}</a>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("contactPageResponseTime");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <p className="mt-3 text-body-sm leading-normal tracking-tight text-muted-foreground text-pretty">{t11}</p>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <div className="lovable-card hardware-surface rounded-[var(--radius-panel)] border border-border/80 shadow-xs mt-8 p-6 sm:p-8">{t9}{t10}{t12}</div>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t1 || $[30] !== t13 || $[31] !== t5 || $[32] !== t7) {
    t14 = <div className="lg:col-span-6 flex flex-col justify-center page-enter"><div className="max-w-xl">{t1}{t5}{t7}{t13}</div></div>;
    $[29] = t1;
    $[30] = t13;
    $[31] = t5;
    $[32] = t7;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("contactFormTitle");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15) {
    t16 = <p className="mb-2 block text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{t15}</p>;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("contactFormSubtitle");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground text-pretty">{t17}</h2>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t16 || $[43] !== t18) {
    t19 = <div className="mb-6">{t16}{t18}</div>;
    $[42] = t16;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ContactForm />;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t19) {
    t21 = <div className="lg:col-span-6 page-enter"><div className="lovable-card hardware-surface rounded-[var(--radius-panel)] border border-border/80 shadow-xs p-6 sm:p-8">{t19}{t20}</div></div>;
    $[46] = t19;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t14 || $[49] !== t21) {
    t22 = <>{t14}{t21}</>;
    $[48] = t14;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  return t22;
}